import { DateTime } from 'luxon';

import { TenderMethod } from '@rygen/rygen-ui/model';
import { loadLuxonDateTime } from '@rygen/rygen-ui/util';

import { TenderResponseCode } from './TenderResponseCode';

export class TenderResponse {
  responseMethod?: TenderMethod;
  responseCode?: TenderResponseCode;
  responseReason?: string;
  responseDate?: DateTime;
  responseComment?: string;
  responsePickupDate?: DateTime;
  responseReferenceNumbers: { typeNaturalId: string; value: string }[] = [];

  constructor(opts?: Partial<TenderResponse>) {
    if (opts?.responseMethod != null) {
      if (typeof opts?.responseMethod === 'string') {
        this.responseMethod = TenderMethod[opts.responseMethod];
      } else {
        this.responseMethod = opts.responseMethod;
      }
    }
    if (opts?.responseCode != null) {
      if (typeof opts?.responseCode === 'string') {
        this.responseCode = TenderResponseCode[opts.responseCode];
      } else {
        this.responseCode = opts.responseCode;
      }
    }
    if (opts?.responseReason != null) {
      this.responseReason = opts.responseReason;
    }
    this.responseDate = loadLuxonDateTime(opts?.responseDate);
    if (opts?.responseComment != null) {
      this.responseComment = opts.responseComment;
    }
    this.responsePickupDate = loadLuxonDateTime(opts?.responsePickupDate);
    if (opts?.responseReferenceNumbers != null) {
      this.responseReferenceNumbers = [...opts.responseReferenceNumbers];
    }
  }
}
